import { useEffect } from "react";

import { useTranslation } from "react-i18next";

import WOW from 'wowjs';

export const ServiciosPage = () => {

    const { t } = useTranslation();

    useEffect(() => {
        window.scrollTo({ top: 0, behavior: "smooth" });
    }, []);

    useEffect(() => {
        new WOW.WOW().init();
    }, []);

    return (
        <>
            <section>
                <div className="hero-section position-relative banner-section gap-2">
                    <img className="icon wow fadeInUp" src="/assets/img/new/elemento.png" />
                    <h1 className="wow fadeInUp">{t("ourServices")}</h1>
                    <img className="icon wow fadeInUp" src="/assets/img/new/elemento2.png" />
                </div>
            </section>
            <section className="section">
                <div className="container">
                    <div className="row">
                        <div className="col-lg-6 ps-lg-5 d-flex flex-column justify-content-center">
                            <h1 className="title-section mb-4 wow fadeIn">{t("logisticsTransportation")}</h1>
                            < p className="text-section mb-4 wow fadeInDown" style={{ textAlign: "justify" }}>{t("logisticsDescription2")}</p>
                            <div className="d-flex align-items-center mb-2 wow fadeIn">
                                <div className="me-2">
                                    <img className="icon" src="/assets/img/new/elemento.png" style={{ width: "30px" }} />
                                </div>
                                <p className="text-section">{t("logisticsItem1")}</p>
                            </div>
                            <div className="d-flex align-items-center mb-2 wow fadeIn">
                                <div className="me-2">
                                    <img className="icon" src="/assets/img/new/elemento.png" style={{ width: "30px" }} />
                                </div>
                                <p className="text-section">{t("logisticsItem2")}</p>
                            </div>
                            <div className="d-flex align-items-center mb-2 wow fadeIn">
                                <div className="me-2">
                                    <img className="icon" src="/assets/img/new/elemento.png" style={{ width: "30px" }} />
                                </div>
                                <p className="text-section">{t("logisticsItem3")}</p>
                            </div>
                            <div className="d-flex align-items-center mb-2 wow fadeIn">
                                <div className="me-2">
                                    <img className="icon" src="/assets/img/new/elemento.png" style={{ width: "30px" }} />
                                </div>
                                <p className="text-section">{t("logisticsItem4")}</p>
                            </div>
                        </div>
                        <div className="col-lg-6 mb-5 d-flex align-items-center justify-content-center">
                            <img className="rounded-2 wow bounceInDown" src="/assets/img/sections/turbo.png" style={{ width: "100%" }} alt="Turbo agroesana" />
                        </div>
                    </div>
                </div>
            </section >
            <section className="section">
                <div className="container">
                    <div className="row">
                        <div className="col-lg-6 ps-lg-5 d-flex flex-column justify-content-center">
                            <h1 className="title-section mb-4 wow fadeIn">Heno angletón</h1>
                            < p className="text-section mb-4 wow fadeInDown" style={{ textAlign: "justify" }}>{t("henoDescription")}</p>
                        </div>
                        <div className="col-lg-6 mb-5 d-flex align-items-center justify-content-center">
                            <div className="img-borde shadow-default wow bounceInDown">
                                <img className="rounded-2" src="/assets/img/sections/heno.png" style={{ width: "100%" }} alt="Turbo agroesana" />
                            </div>
                        </div>
                    </div>
                </div>
            </section>
            <section className="section">
                <div className="container">
                    <div className="row d-flex">
                        <div className="col-lg-6 ps-lg-5 d-flex flex-column justify-content-center order-md-2">
                            <h1 className="title-section mb-4 wow fadeIn">{t("agriculturalSpraying")}</h1>
                            < p className="text-section mb-4 wow fadeInDown" style={{ textAlign: "justify" }}>{t("agriculturalSprayingDescription")}</p>
                        </div>
                        <div className="col-lg-6 d-flex align-items-center justify-content-center order-md-1">
                            <div className="img-borde shadow-default wow bounceInDown">
                                <img className="rounded-2" src="/assets/img/sections/aspersion.png" style={{ width: "100%" }} alt="Turbo agroesana" />
                            </div>
                        </div>
                        
                    </div>
                </div>
            </section>
        </>
    )
}